<template>
<div class="content-page">
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-4">
                    <div class="page-title-box">
                        <h4 class="page-title">알림 내역</h4>
                    </div>
                </div>
                <div class="col-8 mt-3" v-if="Object.keys(groupedNotifications).length > 0">
                    <div class="float-end">
                        <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-soft-info fw-bold">
                                <i class="mdi mdi-email-remove-outline">
                                    {{ unreadNotificationsCnt }}건
                                </i>
                            </button>
                        </div>
                        <div class="btn-group ms-1">
                            <button type="button" class="btn btn-sm btn-light" @click="allReadNotification()">
                                <i class="mdi mdi-check-bold" :class="checkIconClass"></i>
                                모두 읽기
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="Object.keys(groupedNotifications).length > 0">
                <div class="timeline" dir="ltr">
                    <div class="mb-4" v-for="(group, date) in groupedNotifications" :key="date">
                        <div class="timeline-show my-3 text-center">
                            <h5 class="m-0 time-show-name"> {{ date }} </h5>
                        </div>
                        <div class="timeline-lg-item" :class="timelineClass(noti)" v-for="(noti, idx) in group" :key="`noti_${date}_${idx}`" @click="readNotification(noti)">
                            <div class="timeline-desk">
                                <div class="timeline-box" :class="timelineReadClass(noti)">
                                    <span class="timeline-icon">
                                        <i class="mdi mdi-adjust"></i>
                                    </span>
                                    <h4 class="mt-0 mb-1 font-16">
                                        <i class="mdi font-20" :class="notificationIconClass(noti)"></i>
                                        &nbsp;&nbsp;{{ noti.title }}
                                        <i class="mdi font-18 float-end" :class="senderIconClass(noti)"></i>
                                    </h4>
                                    <p class="text-muted mt-2">
                                        <small> {{ DATE_FORMAT(noti.created, "long") }} </small>
                                    </p>
                                    <p> {{ noti.message }}</p>
                                    <div class="d-flex align-items-center">
                                        <h4>
                                            <span class="badge badge-wrap p-1" :class="btnClass(noti)" @click="openModal(noti)">
                                                {{ noti.btn_text }}
                                            </span>
                                        </h4>
                                        <div class="text-end ms-auto multi-user">
                                            <h5 class="font-13 text-muted">
                                                <i class="mdi mdi-clock-outline"></i>&nbsp;{{GET_TIME_AGO(noti.created)}}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center" style="margin-top: 10rem !important" v-else>
                <div class="col-xl-10">
                    <div class="text-center">
                        <img src="assets/images/svg/file-searching.svg" height="140" alt="File not found Image">
                        <h3 class="mt-4">알림 내역이 존재하지 않습니다.</h3>
                        <p class="text-muted mt-3">고시원 등록/수정, 공지사항, 문의 알림 및 다양한 알림들을 받아 보실 수 있습니다.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <NoticeModal :currentNotice="currentNotice" />
    <KosiwonModal :kosiwon="kosiwon" :subMsg="subMsg" />
</div>
</template>

<script>
import {
    DATE_FORMAT,
    GET_TIME_AGO
} from "@/config/date.js";

import NoticeModal from "@/components/modal/Notice";
import KosiwonModal from "@/components/modal/Kosiwon";

export default {
    components: {
        NoticeModal,
        KosiwonModal
    },
    data() {
        return {
            DATE_FORMAT: DATE_FORMAT,
            GET_TIME_AGO: GET_TIME_AGO,

            currentNotice: {
                title: "",
                created: null,
                content: "",
            },

            subMsg: "",

            kosiwon: {
                name: "", // 고시원명
                branch: "", // 지점명
                address_brief: "", // 주소
                address_detail: "", // 상세주소
                owner_name: "", // 업주이름
                company_registration_number: "", // 사업자번호
                url: "", // 홈페이지 URL

                phone_no: "", // 유선번호
                cellphone_no: "", // 원장 핸드폰번호
                virtual_no: "", // 가상번호 (저장 후 등록 가능)
                floor: "", // 고시원 층수
                building_floor: "", // 건물 전체 층수
                price_min: "", // 최소 금액
                price_max: "", // 최대 금액
                deposit: 0, // 보증금

                heating_type: "N", // 난방정보 (default 없음)
                room_type: "", // 룸 타입 (default 없음)

                traffics_subway: [], // 지하철 정보

                intro: "", // 한줄 소개
                description: "", // 상세 설명

                thumbnail_url: null, // 썸네일 이미지 (고시락 메인 썸네일 / 지도 검색 썸네일)

                categories: [{
                    category_name: "기본",
                    groups: [{
                        group_name: "기본",
                        images: []
                    }]
                }],
                options: {},

                private_memo: "", // 비공개 메모
                manager_phone_no: "", // 총무 핸드폰번호
                kakao_talk_receiver: "W", // 카카오 알림톡 대상 (default 원장)
                package_type: "N", // 패키지 타입 (default 없음)
                package_renew_month: 0, // 패지키 갱신주기
                package_register_date: null, // 패키지 계약 시작일
                package_end_date: null, // 패키지 계약 종료일

                is_active: false
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        $(".modal").modal("hide");
        next();
    },
    computed: {
        groupedNotifications() {
            return this.$store.getters.groupedNotifications;
        },
        unreadNotificationsCnt() {
            return this.$store.getters.unreadNotificationsCnt;
        },
        checkIconClass() {
            return this.unreadNotificationsCnt > 0 ? "noti-unread" : "noti-read";
        }
    },
    methods: {
        timelineClass(noti) {
            return noti.sender === "USER" ? "timeline-item-left" : "timeline-item-right";
        },
        timelineReadClass(noti) {
            return noti.is_read ? "timeline-box-read" : "timeline-box-unread";
        },
        notificationIconClass(noti) {
            return noti.is_read ? "mdi-bell-check noti-read" : "mdi-bell-alert noti-unread";
        },
        senderIconClass(noti) {
            return noti.sender === "USER" ? "mdi-email-send-outline" : "mdi-email-receive-outline";
        },
        btnClass(noti) {
            return noti.is_read ? "badge-secondary-lighten" : noti.btn_color;
        },
        readNotification(noti) {
            if (!noti.is_read) {
                this.$store.dispatch("readNotification", noti.pk);
            }
        },
        allReadNotification() {
            if (this.unreadNotificationsCnt > 0) {
                this.$store.dispatch("allReadNotification");
            }
        },
        async openModal(noti) {
            try {
                if (noti.target_url) {
                    if (noti.target_type === "_blank") {
                        window.open(noti.target_url, "_blank");
                    } else {
                        const parts = noti.target_url.split("/");
                        const target_key = parts[parts.length - 1];

                        this.subMsg = noti.sub_message;

                        if (noti.message_type === "notice_register") {
                            const res = await this.axios.get(`/board/${target_key}`);
                            this.currentNotice = res.data.result;
                            this.currentNotice.created = DATE_FORMAT(this.currentNotice.created);
                            $("#notice-modal").modal("show");
                        } else if (noti.message_type.includes("inquiry")) {
                            this.$router.push({
                                path: "/mypage"
                            });
                        } else if (noti.message_type === "kosiwon_register") {
                            const res = await this.axios.get(`/kosiwon/${target_key}`);
                            this.kosiwon = res.data.result;
                            this.kosiwon.created = DATE_FORMAT(noti.created);
                            $("#kosiwon-modal").modal("show");
                        } else {
                            const res = await this.axios.get(`/kosiwon_update/${target_key}`);
                            this.kosiwon = res.data.result;
                            this.kosiwon.created = DATE_FORMAT(noti.created);
                            $("#kosiwon-modal").modal("show");
                        }
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
}
</script>

<style>
[data-bs-theme=dark] {
    --ct-gray-100: #37404a;
}

:root {
    --color-read: #ced4da;
    --color-unread: #ff5b16;
}

@media (max-width: 767.98px) {
    .timeline:before {
        background-color: transparent;
    }
}

.badge-wrap {
    white-space: normal;
    word-wrap: break-word;
}

.timeline-box-read {
    background-color: var(--ct-light);
    border-left: 5px solid var(--color-read);
}

.timeline-box-unread {
    border-left: 5px solid var(--color-unread);
}

.noti-read {
    color: var(--color-read);
}

.noti-unread {
    color: var(--color-unread);
}
</style>
